// Screen `sign-in` — design/screens/SignIn.dc.html — owner: S10 (OIDC, password + TOTP, invites;
// the development member list stays available when DR_DEV_LOGIN is on).
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SignInPage } from '../../features/access/SignInPage';

export const Route = createFileRoute('/_public/login')({
  validateSearch: z.object({
    redirect: z.string().max(2000).optional(),
    error: z.string().max(400).optional(),
    invite: z.string().max(200).optional(),
    workspace: z.string().max(80).optional(),
  }),
  component: LoginRoute,
});

function LoginRoute() {
  const s = Route.useSearch();
  return <SignInPage redirect={s.redirect} error={s.error} invite={s.invite} workspace={s.workspace} />;
}
